import React, {useState, useEffect} from 'react'
import VerMediosdepago from './VerMediosdepago'
import SubirEditMediosdepago from './SubirEditMediosdepago'
import Eliminar  from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import {Titulos, peticionDelete} from '../hooks/Funciones'

const MediosdepagoAdmin = ({baseUrl, titulo, Iglesiasids, Roll}) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [membresias, setMembresias] = useTraeDatos(baseUrl, Iglesiasids, Roll)
	const [copiaDonaciones] = useTraeDatos(baseUrl, Iglesiasids, Roll)
	const [busqueda, setBusqueda] = useState('')
	const TitulosPagina = ['Ver Medios de Pago', 'Crear Medio de Pago', 'Editar Medio de Pago', 'Eliminar Medio de Pago', 'Medios de Pago']

	const seleccionaRegistro = (dato, funcion) => e =>{
		setRegistroSelect({...dato, imagePrev: dato.imagen})
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaDonaciones.filter((item) => {
			if(item.nombre.toLowerCase().includes(termino.toLowerCase())){
				return item
			} 
		})
		setMembresias(resultado)
	}

	const peticionDeletee = () =>{peticionDelete(registroSelect, baseUrl, membresias, setMembresias, setFuncion)}
	useEffect(() => {Titulos (funcion, setTituloPag, TitulosPagina)},[funcion])

	const ReiniciarPaginacion = () => {
		setMembresias(copiaDonaciones)
		setBusqueda('')
	}

	return(
		<div>
			<Header 
				titulo={tituloPag} 
				funcion={funcion} 
				setFuncion={setFuncion} 
				Pagina={'Membresia'} 
				RecibeBusqueda={RecibeBusqueda} 
				busqueda={busqueda}
				resetBusq={ReiniciarPaginacion}
			/>
            {funcion === 'crear' ?
                <SubirEditMediosdepago
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={membresias} 
					setData={setMembresias}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					funcion={funcion}/>

			:null}
			{funcion === 'editar' ?
				<SubirEditMediosdepago
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={membresias} 
					setData={setMembresias}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					registroSelect={registroSelect}
					funcion={funcion}/>
			:null}
			{funcion === 'ver' ?
				<VerMediosdepago
					data={membresias} 
					seleccionaRegistro={seleccionaRegistro}
					baseUrl={baseUrl}
				/>
			:null}
			{funcion === 'eliminar' ?
				<Eliminar 
					nombre={'Operador'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee}/>
				
			:null}
		</div>
	)
}

export default MediosdepagoAdmin